import { Icon } from "@opendash/icons";
import { Button, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { AgencyCreateModal } from "../components/AgencyCreateModal";
import { AgencyUpdateDrawer } from "../components/AgencyUpdateDrawer";
import { TourId } from "../types/TourId";
import { AgencyContext } from "./AgencyContext";

export const AgencySelector = observer(() => {
  const state = useContext(AgencyContext);
  const [createModalVisible, setCreateModalVisible] = useState<boolean>(false);
  const [editDrawerVisible, setEditDrawerVisible] = useState<boolean>(false);

  const handleChange = (value: string) => {
    const foundagency = state.agencies.find((agency) => agency.id === value);
    if (foundagency) {
      state.selectedAgency = foundagency;
    }
  };

  return (
    <>
      <Select
        id={TourId.Agency.overview}
        showSearch
        placeholder="Select an agency"
        optionFilterProp="children"
        value={state.selectedAgency?.id || ""}
        onChange={handleChange}
        style={{ minWidth: 250 }}
        options={state.agencies.map((agency) => {
          return { value: agency.id, label: agency.get("agency_name") };
        })}
      />
      <Button
        id={TourId.Agency.create}
        type="default"
        icon={<Icon icon="fa:plus" />}
        onClick={() => {
          setCreateModalVisible(true);
        }}
        style={{
          marginLeft: 10,
        }}
      ></Button>
      <Button
        type="default"
        onClick={() => {
          setEditDrawerVisible(true);
        }}
        icon={<Icon icon="fa:pen" />}
        style={{
          marginLeft: 10,
        }}
      ></Button>
      <AgencyCreateModal
        open={createModalVisible}
        onOk={() => {
          setCreateModalVisible(false);
          window.location.reload();
        }}
        onCancel={() => {
          setCreateModalVisible(false);
        }}
      ></AgencyCreateModal>
      <AgencyUpdateDrawer
        onOk={() => {
          setEditDrawerVisible(false);
        }}
        open={editDrawerVisible}
      ></AgencyUpdateDrawer>
    </>
  );
});
